// extracted by mini-css-extract-plugin
export default {"criteria":"search-criteria_criteria__6QvEj","small":"search-criteria_small__bruvu"};